import ElementAttributeObserver from '../../obervers/element-attribute-oberver';

export default class Accordion {
	static TOGGLE_BUTTON_SELECTOR = '.et_pb_toggle.et_pb_toggle_item div:first-child';
	static TOGGLE_ITEM_SELECTOR = '.et_pb_toggle.et_pb_toggle_item';
	static TOGGLE_SELECTOR = '.et_pb_toggle.et_pb_toggle_item h5';

	start() {
		if (!$(Accordion.TOGGLE_ITEM_SELECTOR).length) {
			return;
		}
		this.attachListeners();
	}

	attachListeners() {
		this.toggleExpand();
		this.toggleAttributeChanged();
	}

	toggleExpand() {
		const $ = jQuery;
		$(Accordion.TOGGLE_SELECTOR).on('keypress', function (event) {
			if (event.key === 'Enter') {
				$(this).click();
			}
		});
		$(Accordion.TOGGLE_SELECTOR).on('click', function () {
			const $element = $(this);
			if ($element.parent().parent().hasClass('et_pb_toggle_close')) {
				$element.attr('aria-expanded', 'true');
			} else {
				$element.attr('aria-expanded', 'false');
			}
		});
	}

	toggleAttributeChanged() {
		const $ = jQuery;

		$(Accordion.TOGGLE_ITEM_SELECTOR).get().forEach((item) => {
			const itemObserver = new ElementAttributeObserver(item);
			itemObserver.onUpdate(() => {
				$(item).removeAttr('tabindex');
			});
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/divi/controllers/accordion.js